import { CommonModule } from '@angular/common';
import { Component, Input, Output, EventEmitter, Injectable, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { ProgressiveTypeaheadDirective } from '../../../directives/progressive-typeahead.directive';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_FORMATS, NativeDateAdapter, DateAdapter } from '@angular/material/core';
import { LoginAttemptSearchFilter } from '../../../models/loginAttemptSearchFilter';

export const DD_MM_YYYY_FORMAT = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  override parse(value: any): Date | null {
    if (!value) return null;

    if (typeof value === 'string') {
      // Handle DD/MM/YYYY format
      const parts = value.split('/');
      if (parts.length === 3) {
        const day = parseInt(parts[0], 10);
        const month = parseInt(parts[1], 10) - 1; // Month is 0-indexed
        const year = parseInt(parts[2], 10);

        if (!isNaN(day) && !isNaN(month) && !isNaN(year)) {
          return new Date(year, month, day);
        }
      }
    }

    return super.parse(value);
  }

  override format(date: Date, displayFormat: Object): string {
    if (!date) return '';

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
}

@Component({
  selector: 'app-login-attempt-search-box',
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    MatInputModule,
    MatFormFieldModule,
    MatSelectModule,
    ProgressiveTypeaheadDirective,
    MatDatepickerModule,
    MatNativeDateModule,
    FormsModule],
  providers: [
    { provide: DateAdapter, useClass: CustomDateAdapter },
    { provide: MAT_DATE_FORMATS, useValue: DD_MM_YYYY_FORMAT }
  ],
  templateUrl: './login-attempt-search-box.component.html',
  styleUrl: './login-attempt-search-box.component.scss'
})
export class LoginAttemptSearchBoxComponent implements OnInit {
  @Input() isSearchVisible: boolean = false;
  /** Pre-populates the form so the list's default filter (e.g. last 10 days) is visible and editable. */
  @Input() initialFilter?: LoginAttemptSearchFilter;
  @Output() loginAttemptSearchFilter = new EventEmitter<LoginAttemptSearchFilter>();

  searchForm: LoginAttemptSearchFilter = {
    username: undefined,
    ip: undefined,
    isSuccessful: undefined,
    attemptDateFrom: undefined,
    attemptDateTo: undefined
  };

  ngOnInit(): void {
    if (this.initialFilter) {
      this.searchForm = { ...this.searchForm, ...this.initialFilter };
    }
  }

  onSearch(): void {
    this.loginAttemptSearchFilter.emit({ ...this.searchForm });
  }

  clearSearch(): void {
    this.searchForm = {
      username: undefined,
      ip: undefined,
      isSuccessful: undefined,
      attemptDateFrom: undefined,
      attemptDateTo: undefined
    };
    this.loginAttemptSearchFilter.emit({ ...this.searchForm });
  }
}
